"use strict";
exports.__esModule = true;
exports.requiredAction = void 0;
var requiredActionProviderRepresentation_1 = require("./defs/requiredActionProviderRepresentation");
var client_1 = require("./client");
exports.requiredAction = requiredActionProviderRepresentation_1.RequiredActionAlias;
exports["default"] = client_1.KeycloakAdminClient;
//# sourceMappingURL=index.js.map